import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import ShiftScheduleOutlet from "../../components/shift-schedule/ShiftScheduleOutlet";
import { useShiftData } from "../../hooks/shiftData";

const DepartmentalShift = () => {
    const { setShiftData } = useShiftData();

    const location = useLocation();
    const segments = location.pathname.split('/').filter(Boolean);
    const queryParams = new URLSearchParams(location.search);
    
    const department = queryParams.get('label');
    const departmentslug = segments?.[2];

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    useEffect(() => {
        setShiftData('payperiod', null);
        setShiftData('employee', null);
    }, setShiftData);

    return (
        <div className="shift-schedules">
            <div className="page-header">
                <div className="title">
                    <h1>Shift Schedules</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to='/dtr'>DTR</NavLink>
                        </li>
                        <li>
                            <>{
                                (role === 'admin')
                                    ? (<NavLink to='/dtr/shifts'>Shifts</NavLink>)
                                    : (<span>Shifts</span>)
                            }</>
                        </li>
                        <li>
                            <NavLink to="/dtr/shift-schedules">Schedules</NavLink>
                        </li>
                        <li>
                            <span>{department}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <ShiftScheduleOutlet departmentslug={departmentslug} />
        </div>
    )
}

export default DepartmentalShift;